import { render, staticRenderFns } from "./WtActionMenuItem.vue?vue&type=template&id=a35b7a70&scoped=true&lang=pug&"
import script from "./WtActionMenuItem.vue?vue&type=script&lang=js&"
export * from "./WtActionMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./WtActionMenuItem.vue?vue&type=style&index=0&id=a35b7a70&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35b7a70",
  null
  
)

export default component.exports